import { IAttentionDay } from "../../../domain/attentiondays/IAttentionDay";
import { parseISO } from "date-fns/esm";

export const mapAttentionday = (x: any): IAttentionDay => ({
    id: x.id,
    name: x.name,
    start: parseISO(x.start),
    end: parseISO(x.end),
    kind: x.kind
});
